//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
export default {
  components: {
    SuccessDialog,
  },
  data: () => ({
    authorize_view: true,
    authorize_add: true,
    authorize_edit: true,
    authorize_del: true,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    search: "",
    dialogadd: false,
    dialogedit: false,
    headers: [
      { text: "ID", value: "id" },
      { text: "Assignment Name", value: "name" },
      // { text: "address", value: "address" },
      // { text: "provice", value: "provice" },
      // { text: "zipcode", value: "zipcode" },
      { text: "Company Name", value: "companyname" },
      { text: "Department Name", value: "departmentname" },

      { text: "Status", value: "status" },
      { text: "Action", value: "actions" },
    ],
    desserts: [],
    itemadd: {
      name: "",
      company_id: 0,
      customer_id: null,
      department_id: 0,
      status: "ACTIVE",
      create_by: localStorage.getItem(server.USER_ID),
    },
    itemeditid: 0,
    itemedit: {
      name: "",
      company_id: 0,
      customer_id: null,
      department_id: 1,
      status: "",
      update_by: localStorage.getItem(server.USER_ID),
    },
    companyAll: [],
    departmentShow: [],
    departmentShowEdit: [
      {
        id: 0,
      },
    ],
    statusall: ["ACTIVE", "INACTIVE"],
    customer_list: [],
    // filters (draft = ค่าที่กำลังเลือก, applied = ค่าที่กด Apply แล้ว)
    filterClient: "ALL",
    filterDepartment: "ALL",
    filterStatus: "ALL",
    applied: { search: "", client: "ALL", department: "ALL", status: "ALL" },
    sortAsc: true,
    page: 1,
    rowsPerPage: 20,
  }),
  computed: {
    form() {
      return this.dialogedit ? this.itemedit : this.itemadd;
    },
    clientFilterItems() {
      return [{ id: "ALL", name: "All clients" }, ...this.customer_list];
    },
    departmentFilterItems() {
      const names = [...new Set(this.desserts.map((d) => d.departmentname).filter(Boolean))].sort();
      return [{ text: "All departments", value: "ALL" }, ...names.map((n) => ({ text: n, value: n }))];
    },
    statusFilterItems() {
      return [
        { text: "All statuses", value: "ALL" },
        { text: "Active", value: "ACTIVE" },
        { text: "Inactive", value: "INACTIVE" },
      ];
    },
    // กรองทุกอย่างยกเว้น status (ใช้นับจำนวนใน tab)
    baseRows() {
      const q = (this.applied.search || "").trim().toLowerCase();
      return this.desserts.filter((d) => {
        if (q) {
          const hay = `${d.name || ""} ${this.assignmentCode(d.id)}`.toLowerCase();
          if (!hay.includes(q)) return false;
        }
        if (this.applied.client !== "ALL" && String(d.customer_id) !== String(this.applied.client)) return false;
        if (this.applied.department !== "ALL" && d.departmentname !== this.applied.department) return false;
        return true;
      });
    },
    filteredRows() {
      const rows = this.baseRows.filter((d) => {
        if (this.applied.status === "ALL") return true;
        return this.applied.status === "ACTIVE" ? this.isActive(d.status) : !this.isActive(d.status);
      });
      const dir = this.sortAsc ? 1 : -1;
      return [...rows].sort((a, b) => dir * String(a.name || "").localeCompare(String(b.name || "")));
    },
    tabs() {
      const active = this.baseRows.filter((d) => this.isActive(d.status)).length;
      return [
        { text: "All", value: "ALL", count: this.baseRows.length },
        { text: "Active", value: "ACTIVE", count: active },
        { text: "Inactive", value: "INACTIVE", count: this.baseRows.length - active },
      ];
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.filteredRows.length / this.rowsPerPage));
    },
    pagedRows() {
      const start = (this.page - 1) * this.rowsPerPage;
      return this.filteredRows.slice(start, start + this.rowsPerPage);
    },
    pageNumbers() {
      const total = this.pageCount;
      let start = Math.max(1, this.page - 2);
      const end = Math.min(total, start + 4);
      start = Math.max(1, end - 4);
      const arr = [];
      for (let i = start; i <= end; i++) arr.push(i);
      return arr;
    },
    showingText() {
      const total = this.filteredRows.length;
      if (!total) return "Showing 0 assignments";
      const start = (this.page - 1) * this.rowsPerPage + 1;
      const end = Math.min(start + this.pagedRows.length - 1, total);
      return `Showing ${start}–${end} of ${total} assignments`;
    },
  },
  watch: {
    pageCount(v) {
      if (this.page > v) this.page = v;
    },
  },
  async mounted() {
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let token = localStorage.getItem(server.USER_ID);

    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.getcompanydata();
    await this.loadCompany();
    await this.loadCustomer();
  },
  methods: {
    // ===== UI helpers =====
    assignmentCode(id) {
      return id ? `ASN-${String(id).padStart(3, "0")}` : "";
    },
    isActive(status) {
      return String(status || "").toUpperCase() === "ACTIVE";
    },
    applyFilters() {
      this.applied = {
        search: this.search,
        client: this.filterClient || "ALL",
        department: this.filterDepartment || "ALL",
        status: this.filterStatus || "ALL",
      };
      this.page = 1;
    },
    resetFilters() {
      this.search = "";
      this.filterClient = "ALL";
      this.filterDepartment = "ALL";
      this.filterStatus = "ALL";
      this.applyFilters();
    },
    setTab(status) {
      this.filterStatus = status;
      this.applied = { ...this.applied, status };
      this.page = 1;
    },
    closeDialog() {
      if (this.dialogedit) this.canceledit();
      else this.canceladd();
    },
    onCompanyChange() {
      if (this.dialogedit) this.showdepartNameEdit();
      else this.showdepartName();
    },
    async loadCustomer() {
      try {
        const result = await api.getAllCustomerListactiveCompany({
          params: { company_id: localStorage.getItem(server.COMPANYID) },
        });
        // id จาก BIGINT อาจมาเป็น string หรือ number → แปลงเป็น string ทั้งหมดให้ v-autocomplete จับคู่ได้
        this.customer_list = (result.data || []).map((c) => ({ ...c, id: String(c.id) }));
      } catch (e) {
        console.error(e);
      }
    },
    async toggleStatus(item) {
      this.itemeditid = item.id;
      this.itemedit = {
        name: item.name,
        company_id: item.company_id,
        customer_id: item.customer_id != null && item.customer_id !== "" ? String(item.customer_id) : null,
        department_id: item.department_id,
        status: this.isActive(item.status) ? "INACTIVE" : "ACTIVE",
        update_by: localStorage.getItem(server.USER_ID),
      };
      await this.savedataedit();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async loadCompany(id) {
      // const result = await api.getAllCompany(id);
      // this.companyAll = result.data;

      var result;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   result = await api.getAllCompany();
      // } else {
      result = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
      // }
      this.companyAll = result.data;
    },
    async getcompanydata() {
      // const result = await api.getAllJobtitle();
      // this.desserts = result.data;

      var result;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   result = await api.getAllJobtitle();
      // } else {
      result = await api.getAllJobtitle_By_CompanyID(
        localStorage.getItem(server.COMPANYID)
      );
      // }

      this.desserts = result.data;
      console.log("this.desserts: ")
      console.log(this.desserts)

      // this.$showLoader();
      this.$hideLoader();
    },

    openadd() {
      this.itemadd = {
        name: "",
        company_id: this.companyAll.length === 1 ? this.companyAll[0].id : 0,
        customer_id: null,
        department_id: 0,
        status: "ACTIVE",
        create_by: localStorage.getItem(server.USER_ID),
      };
      this.dialogadd = true;
      if (this.itemadd.company_id) this.showdepartName();
    },
    canceladd() {
      this.dialogadd = false;
    },
    canceledit() {
      this.dialogedit = false;
    },
    async savedata() {
      if (this.itemadd.name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Assignment Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemadd.company_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Company",
          "text-h5 red--text text-center"
        );
        return;
      }
      // if (
      //   this.itemadd.department_id == 0 ||
      //   this.itemadd.department_id == "0"
      // ) {
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Failed",
      //     "Please select Department",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }
      if (!this.itemadd.customer_id) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Client",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemadd.department_id || this.itemadd.department_id == "0") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Department",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemadd.status == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Status",
          "text-h5 red--text text-center"
        );
        return;
      }
      //console.log(this.itemadd)
      this.$showLoader();
      const res_add = await api.addJobtitle(this.itemadd);
      this.$hideLoader();
      if (res_add.status == 200) {

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Add data success",
          "text-h5 green--text text-center"
        );
        this.getcompanydata();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Add data Failed",
          "text-h5 red--text text-center"
        );
      }
      this.dialogadd = false;
    },
    async showdepartName() {
      //  getAllDepartment_By_CompanyID
      const result = await api.getNewAllDepartment_By_CompanyID(
        this.itemadd.company_id
      );
      this.departmentShow = result.data;
    },
    async showdepartNameEdit() {
      //  getAllDepartment_By_CompanyID
      const result = await api.getNewAllDepartment_By_CompanyID(
        this.itemedit.company_id
      );

      //console.log(result.data)
      if (result.data.length == 0) {
        this.itemedit.department_id = 0;
        this.departmentShowEdit = [];
      } else {
        this.departmentShowEdit = result.data;
      }
    },
    async openeditItem(item) {
      this.$showLoader();

      const result = await api.getNewAllDepartment_By_CompanyID(item.company_id);
      this.departmentShowEdit = result.data;

      this.itemeditid = item.id;
      this.itemedit.name = item.name;
      this.itemedit.company_id = item.company_id;
      this.itemedit.customer_id =
        item.customer_id != null && item.customer_id !== "" ? String(item.customer_id) : null;
      this.itemedit.department_id = item.department_id;
      this.itemedit.status = item.status;
      this.dialogedit = true;

      this.$hideLoader();
    },
    async savedataedit() {
      if (this.itemedit.name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Assignment Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemedit.company_id == 0 || this.itemedit.company_id == "0") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Company",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (!this.itemedit.customer_id) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Client",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemedit.status == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Status",
          "text-h5 red--text text-center"
        );
        return;
      }

      await this.$showLoader();
      const res_update = await api.updateJobtitle(
        this.itemeditid,
        this.itemedit
      );

      if (res_update.status == 200 || res_update.status == 201) {
        await this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Update data success",
          "text-h5 green--text text-center"
        );
        this.getcompanydata();
      } else {
        await this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update data Failed",
          "text-h5 red--text text-center"
        );
      }


      this.dialogedit = false;
    },
  },
  beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
